// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"303":"b6222894","745":"4bc9838d","837":"2f1f6a28","966":"4bc9838d"}[chunkId] + ".chunk.css";
};